class ChangeCompanyStateModalController {
    constructor() {
        // this.companyInfo = this.resolve.companyInfo;
        // this.changeToState = this.resolve.changeToState;
    }
    $onInit() {
        this.companyInfo = this.resolve.companyInfo;
        this.changeToState = this.resolve.changeToState;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    onCompanyDelete() {
        this.callbackObject.callbackType = 'delete';
        this.closeModal();
    }
    onStateChange() {
        this.callbackObject.callbackType = 'stateChange';
        this.closeModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './change-company-state-modal.html';
import * as TEMPLATE from 'raw-loader!./change-company-state-modal.html';
export const ChangeCompanyStateModalComponent = {
    selector: 'changeCompanyStateModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ChangeCompanyStateModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/changeCompanyStateModal/change-company-state-modal.html'
    }
};
//# sourceMappingURL=change-company-state-modal.component.js.map